// vendor
import { SetupContext } from "@vue/composition-api";
// project
import * as AppModal from "@/AppModal";
import * as StudyAPI from "@/services/api/studies";
import { useAssets } from "@/hooks/useAssets";
import { useTags } from "@/hooks/useTags";

export const createStudy = (context:SetupContext) => {
	AppModal.createStudy({}, async (r) => {
		const { name, study, version, language, openDashboard } = r;
		const s = await StudyAPI.createStudy({ name, blueprint:`${study}@${version}`, language });
		if(openDashboard){
			context.root.$router.push({
				name:"Run.Group",
				params:{
					groupId:s._id,
				}
			});
		}
	});
};

export const createAsset = (type:string, context:SetupContext) => {
	const assetHooks = useAssets();
	const tagHooks = useTags();
	AppModal.createAsset({ type }, async (r) => {
		const { name, tags, openEditor } = r;
		const a = await assetHooks.createAsset(type, name);
		await Promise.all(tags.map(t => tagHooks.tagItem(t, a._id, "asset")));
		if(openEditor){
			context.root.$router.push({
				name:"asset.edit",
				params:{
					assetId:a._id,
				}
			})
		}
	});
};